<template>
  <div class="solicitud-centro-costo-container">
    <v-card
      :disabled="loaderStore.active"
      :loading="loaderStore.active"
      class="form-container mx-auto"
      elevation="0"
    >
      <template #loader>
        <v-progress-linear
          v-if="loaderStore.active"
          color="black"
          :height="5"
          indeterminate
        />
      </template>
      <v-toolbar 
        class="toolbar-container" 
        color="primary"
      >
        <v-toolbar-title :class="!smAndUp ? 'text-center' : ''">
          <v-icon>
            mdi-cash-multiple
          </v-icon>
          Solicitud de Centro de Costo
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="form-text pa-0">
        <v-form
          id="steps_parent_container"
          ref="form"
          class="scrollable-form"
          validate-on="blur"
          @submit.prevent="handleNext"
        >
          <v-stepper
            v-model="store.currentStep"
            :mobile="smAndDown"
            :alt-labels="!smAndDown"
            flat
          >
            <v-stepper-header class="elevation-0">
              <template
                v-for="(step, index) in store.stepsHeaders"
                :key="index"
              >
                <v-divider v-if="index" />
                <v-stepper-item
                  :title="step"
                  :step="`Step {{ index + 1 }}`"
                  :value="index + 1"
                  :complete="
                    store.currentStep > index + 1 ||
                      store.currentStep == store.stepsHeaders.length
                  "
                />
              </template>
            </v-stepper-header>
            <v-stepper-window>
              <v-stepper-window-item
                v-for="(item, index) in store.stepsHeaders"
                :key="index"
                :value="index + 1"
              >
                <v-card
                  v-if="store.currentStep === 1"
                  flat
                >
                  <v-text-field
                    v-model="store.formData.centroCosto"
                    :rules="store.rules.centroCosto"
                    label="Centro de Costo"
                    required
                  />
                </v-card>

                <v-card
                  v-if="store.currentStep === 2"
                  flat
                >
                  <v-text-field
                    v-model="store.formData.descripcion"
                    :rules="store.rules.descripcion"
                    label="Descripción"
                    required
                  />
                </v-card>

                <v-text-field
                  v-model="store.formData.area"
                  :rules="store.rules.area"
                  label="Área"
                  required
                />

                <v-text-field
                  v-model="store.formData.gerencia"
                  :rules="store.rules.gerencia"
                  label="Gerencia"
                  required
                />

                <v-text-field
                  v-model="store.formData.departamento"
                  :rules="store.rules.departamento"
                  label="Departamento"
                  required
                />

                <v-number-input
                  v-model="store.formData.presupuesto"
                  :rules="store.rules.presupuesto"
                  label="Presupuesto"
                  required
                />

                <v-card
                  v-if="store.currentStep === 3"
                  flat
                >
                  <v-number-input
                    v-model="store.formData.monto"
                    :rules="store.rules.monto"
                    label="Monto"
                    required
                  />
                </v-card>

                <v-date-input
                  v-model="store.formData.fechaInicio"
                  :rules="store.rules.fechaInicio"
                  label="Fecha de Inicio"
                  required
                />

                <v-number-input
                  v-model="store.formData.duracion"
                  :min="1"
                  :rules="store.rules.duracion"
                  label="Duración (meses)"
                  required
                />

                <v-text-field
                  v-model="store.formData.objetivo"
                  class="mt-4"
                  :rules="store.rules.objetivo"
                  label="Objetivo"
                  required
                />

                <v-date-input
                  v-model="store.formData.fechaFin"
                  prepend-icon="mdi-calendar"
                  :rules="store.rules.fechaFin"
                  label="Fecha de Fin"
                  required
                />

                <v-autocomplete
                  v-model="store.formData.tipoProyecto"
                  :items="store.tiposProyecto"
                  :rules="store.rules.tipoProyecto"
                  label="Tipo de Proyecto"
                  required
                />

                <v-autocomplete
                  v-model="store.formData.estado"
                  :items="store.estados"
                  :rules="store.rules.estado"
                  label="Estado"
                  required
                />

                <v-card
                  v-if="store.currentStep === 4"
                  flat
                >
                  <v-number-input
                    v-model="store.formData.costoTotal"
                    :rules="store.rules.costoTotal"
                    label="Costo Total"
                    required
                  />
                </v-card>

                <v-text-field
                  v-model="store.formData.responsable"
                  class="mt-4"
                  :rules="store.rules.responsable"
                  label="Responsable"
                  required
                />

                <v-text-field
                  v-model="store.formData.supervisor"
                  class="mt-4"
                  :rules="store.rules.supervisor"
                  label="Supervisor"
                  required
                />

                <v-text-field
                  v-model="store.formData.ubicacion"
                  class="mt-4"
                  :rules="store.rules.ubicacion"
                  label="Ubicación"
                  required
                />

                <v-text-field
                  v-model="store.formData.contacto"
                  class="mt-4"
                  :rules="store.rules.contacto"
                  label="Contacto"
                  required
                />

                <v-text-field
                  v-model="store.formData.telefono"
                  class="mt-4"
                  :rules="store.rules.telefono"
                  label="Teléfono"
                  required
                />

                <v-text-field
                  v-model="store.formData.email"
                  class="mt-4"
                  :rules="store.rules.email"
                  label="Email"
                  required
                />

                <v-text-field
                  v-model="store.formData.observaciones"
                  class="mt-4"
                  :rules="store.rules.observaciones"
                  label="Observaciones"
                  required
                />

                <v-card
                  v-if="store.currentStep === 5"
                  flat
                >
                  <v-scale-transition 
                    group 
                    hide-on-leave
                  >
                    <EmptyState v-if="emptyStateStore.active" />
                  </v-scale-transition>
                </v-card>

                <v-scale-transition origin="top left">
                  <small
                    v-if="formMessage.active"
                    class="font-weight-bold text-subtitle-2 text-red"
                  >
                    <v-icon>{{ formMessage.icon }}</v-icon>
                    {{ formMessage.content }}
                  </small>
                </v-scale-transition>
              </v-stepper-window-item>
            </v-stepper-window>
            <v-stepper-actions>
              <template #prev>
                <v-btn
                  v-if="!store.isFirstStep && !store.requestFinished"
                  variant="text"
                  @click="store.prevStep()"
                >
                  Regresar
                </v-btn>
              </template>
              <template #next>
                <v-btn
                  v-if="!store.requestFinished"
                  variant="text"
                  :disabled="false"
                  @click="handleNext"
                >
                  {{ nextButtonLabel }}
                </v-btn>
              </template>
            </v-stepper-actions>
          </v-stepper>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable */
import { useLoaderStore } from '../stores/loader'
import { useDisplay } from 'vuetify'
import axios from "axios";
import { VNumberInput } from "vuetify/labs/VNumberInput";
import { VDateInput } from "vuetify/labs/VDateInput";
import EmptyState from "../components/EmptyState.vue";
import Helpers from "../components/helper.js";

export default {
  name: 'SolicitudCentroCosto',
  components: {
    VNumberInput,
    VDateInput,
    EmptyState,
  },
  setup() {
    const loaderStore = useLoaderStore()
    const { smAndUp, smAndDown } = useDisplay()
    return {
      loaderStore,
      smAndUp,
      smAndDown
    }
  },
  data() {
    return {
      store: {
        currentStep: 1,
        isFirstStep: true,
        requestFinished: false,
        formData: {
          centroCosto: "",
          descripcion: "",
          area: "",
          gerencia: "",
          departamento: "",
          presupuesto: null,
          monto: null,
          fechaInicio: null,
          duracion: null,
          objetivo: "",
          fechaFin: null,
          tipoProyecto: "",
          estado: "",
          costoTotal: null,
          responsable: "",
          supervisor: "",
          ubicacion: "",
          contacto: "",
          telefono: "",
          email: "",
          observaciones: ""
        },
        rules: {
          centroCosto: [(v) => !!v || "Campo requerido"],
          descripcion: [(v) => !!v || "Campo requerido"],
          area: [(v) => !!v || "Campo requerido"],
          gerencia: [(v) => !!v || "Campo requerido"],
          departamento: [(v) => !!v || "Campo requerido"],
          presupuesto: [(v) => !!v || "Campo requerido"],
          monto: [(v) => !!v || "Campo requerido"],
          fechaInicio: [(v) => !!v || "Campo requerido"],
          duracion: [(v) => !!v || "Campo requerido"],
          objetivo: [(v) => !!v || "Campo requerido"],
          fechaFin: [(v) => !!v || "Campo requerido"],
          tipoProyecto: [(v) => !!v || "Campo requerido"],
          estado: [(v) => !!v || "Campo requerido"],
          costoTotal: [(v) => !!v || "Campo requerido"],
          responsable: [(v) => !!v || "Campo requerido"],
          supervisor: [(v) => !!v || "Campo requerido"],
          ubicacion: [(v) => !!v || "Campo requerido"],
          contacto: [(v) => !!v || "Campo requerido"],
          telefono: [(v) => !!v || "Campo requerido"],
          email: [(v) => !!v || "Campo requerido"],
          observaciones: [(v) => !!v || "Campo requerido"]
        },
        stepsHeaders: [
          "Validacion de Correo",
          "Datos Generales del Centro de Costo",
          "Condiciones Operativas",
          "Condiciones Operativas Adicionales",
          "Envio de Solicitud",
        ],
        tiposProyecto: [],
        estados: []
      },
      formMessage: {},
      emptyStateStore: {
        active: false
      }
    };
  },
  async mounted() {
    try {
      console.log(process.env.VUE_APP_URL);
      console.log(process.env.VUE_APP_TOKKEN);
      // setTimeout(() => {
      //   Helpers.triggerSnackbar("Correo electronico invalido, intenta con otro","#b54c4d", "#f9edef", "mdi-alert-circle-outline",-1);
      // }, 2000);

      // setTimeout(() => {
      //   Helpers.triggerSnackbar("Ahooora sii","#647c5e", "#dcf3d6", "mdi-alert-circle-outline",-1);
      // }, 4000);

      // const validateToken = await axios.post(
      //   `${process.env.VUE_APP_URL}/login/verifyChangeToken`,
      //   {
      //     token: queryToken,
      //     appToken: process.env.VUE_APP_TOKKEN,
      //   }
      // );
      // let tempSenders = await this.fetchData(
      //   `select id, Name, empresa.id as 'empresaId', empresa.Name as 'empresaName' from Personal_Mensajeria where id is not null`
      // );
      // console.log(tempSenders);
      // if (
      //   Array.isArray(tempSenders?.data?.recordMap?.data) &&
      //   tempSenders?.data?.recordMap?.data?.length
      // ) {
      //   for (let index = 0; index < tempSenders?.data?.recordMap?.data.length; index++) {
      //     const currentSender = tempSenders?.data?.recordMap?.data[index];
      //     this.allSenders.push({
      //       id: currentSender?.id || "",
      //       name: currentSender?.Name || "",
      //       empresaId: currentSender?.empresaId || "",
      //       empresaName: currentSender?.empresaName || "",
      //     });
      //   }
      // }
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    async handleNext() {
      try {
        const valid = await this.$refs.form.validate();
        if (!valid.valid) {
          return;
        }
        
        if (this.store.currentStep === this.store.stepsHeaders.length) {
          // Handle form submission
          this.store.requestFinished = true;
        } else {
          this.store.currentStep++;
          this.store.isFirstStep = this.store.currentStep === 1;
        }
      } catch (error) {
        console.error(error);
        this.formMessage = {
          active: true,
          icon: "mdi-alert-circle",
          content: "Ocurrió un error al procesar la solicitud"
        };
      }
    },
    prevStep() {
      this.store.currentStep--;
      this.store.isFirstStep = this.store.currentStep === 1;
    },
    async fetchData(criteria) {
      try {
        const userData = await axios.get(`${process.env.VUE_APP_URL}/fetchCoqlData`, {
          params: {
            criteria: criteria,
          },
        });
        return userData;
      } catch (error) {
        console.log(error);
        return error;
      }
    },
  },
  computed: {
    nextButtonLabel() {
      return this.store.currentStep === this.store.stepsHeaders.length ? "Enviar" : "Continuar";
    },
    showPrevButton() {
      return this.store.currentStep < this.store.stepsHeaders.length;
      // return (
      //   (this.getEmptyState.active && this.getEmptyState.icon == "$error") ||
      //   (!this.getEmptyState.active && this.currentStep < this.stepsHeaders.length)
      // );
    },
    showNextButton() {
      return this.store.currentStep < this.store.stepsHeaders.length;
    },
  },
};
</script>
<style scoped>
.form-container {
  width: 50%;
  min-width: 1500px;
  margin: 30px 0px;
  @media only screen and (max-width: 600px) {
    margin: 0px;
  }
}

.solicitud-envios-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.second-container {
  width: 100vw;
  /* height: 100vh; */
}

/* Make the form scrollable */
.scrollable-form {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
}
.image-container {
  margin: auto;
  width: 150px;
  margin-bottom: 10px;
}
</style>
